import { Skeleton, styled } from '@mui/material'

export const FormsGridRowsContainer: React.FC<React.HTMLAttributes<HTMLDivElement>> = styled('div')(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(2),
}))

export const FormsGridItemContainer: React.FC<React.HTMLAttributes<HTMLDivElement>> = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    width: `calc(50% - ${theme.spacing(1)})`,
  },

  [theme.breakpoints.up('md')]: {
    width: `calc(33.33% - ${theme.spacing(1.5)})`,
  },

  [theme.breakpoints.up('lg')]: {
    width: `calc(25% - ${theme.spacing(1.5)})`,
  },
}))

export const FormsGridItemPlaceholder: React.FC = () => (
  <FormsGridItemContainer>
    <Skeleton variant='rounded' height={215} />
  </FormsGridItemContainer>
)
